import React from 'react';
import PropTypes from 'prop-types';

import { ErrorPage, BlockedBrokerPage } from 'common/components';

const InterfaceErrorHandler = ({ error }) => {
  switch (error) {
    case 418:
      return <ErrorPage caption="Sorry, the broker is not available now" />;
    case 403:
      return <BlockedBrokerPage />;
    default:
      return (
        <ErrorPage
          caption="Maintenance in Progress"
          description="We are currently performing a system critical maintenance to improve service performance.\n The system will be available again shortly.\n We apologize for the inconvenience of this sudden temporary unavailability."
        />
      );
  }
};

InterfaceErrorHandler.propTypes = {
  error: PropTypes.number.isRequired,
};

export default InterfaceErrorHandler;
